import { Box, Select, MenuItem, Button, Stack, FormControl, InputLabel, Grid } from "@mui/material";

import FilterRow from "./row_filter";
import MDBox from "theme/components/MDBox";
import MDButton from "theme/components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

const AGG_FUNCS = ["SUM", "COUNT", "AVG", "MIN", "MAX", "DISPLAY"];

export default function AggregationBlock({ data, fields, onChange, onRemove }) {
  const addFilter = () => {
    onChange({
      ...data,
      filters: [
        ...data.filters,
        {
          field: fields[0].key,
          op: "==",
          value: "",
        },
      ],
    });
  };

  return (
    <Box mt={3} mb={2}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4} lg={4}>
          <MDBox>
            <FormControl sx={{ minWidth: 120, width: "100%" }}>
              <InputLabel>Select Function</InputLabel>
              <Select
                label="Select Function"
                value={data.func}
                onChange={(e) =>
                  onChange({
                    ...data,
                    func: e.target.value,
                  })
                }
                sx={{ padding: "12px", paddingLeft: "3px" }}
                defaultValue=""
              >
                <MenuItem value=""> -- SELECT FUNCTION --</MenuItem>
                {AGG_FUNCS.map((f) => (
                  <MenuItem key={f} value={f}>
                    {f}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={7} lg={7}>
          <MDBox>
            <FormControl sx={{ minWidth: 120, width: "100%" }}>
              <InputLabel>Select Field</InputLabel>
              <Select
                label="Select Field"
                value={data.field}
                onChange={(e) =>
                  onChange({
                    ...data,
                    field: e.target.value,
                  })
                }
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                <MenuItem> -- Select Field --</MenuItem>
                {fields.map((f) => (
                  <MenuItem key={f.key} value={f.key}>
                    {f.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={1} lg={1}>
          <MDBox align="right">
            <IconButton color="error" onClick={onRemove}>
              <DeleteIcon />
            </IconButton>
          </MDBox>
        </Grid>
      </Grid>

      {data.filters.map((f, i) => (
        <FilterRow
          key={i}
          data={f}
          fields={fields}
          onChange={(nf) => {
            let copy = [...data.filters];
            copy[i] = nf;
            onChange({
              ...data,
              filters: copy,
            });
          }}
          onRemove={() => {
            let copy = [...data.filters];
            copy.splice(i, 1);
            onChange({
              ...data,
              filters: copy,
            });
          }}
        />
      ))}
      <MDBox mt={1} align="right" pt={1}>
        <MDButton color="dark" size="small" onClick={addFilter}>
          Add Filter
        </MDButton>
      </MDBox>
    </Box>
  );
}
